import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { translate } from 'translations/translator';
import m from 'translations/variants/modals';
import { ModalPadding } from 'styles/style-constants';
const getTranslation = (key: m) => translate('modals', key);

type Props = {
  onSubmit: () => void;
};

export const EditAssignmentModal: React.FC<Props> = ({ onSubmit }) => {
  const classes = useStyles();
  const [, { closeModal }] = useModal();

  const withCloseModal = cb => () => {
    cb();
    closeModal();
  };

  return (
    <Box className={classes.container}>
      <Box>
        <Typography variant="h6">{getTranslation(m.cannotEdit)}</Typography>
      </Box>
      <Typography variant="body2" style={{ fontWeight: 300 }}>
        {getTranslation(m.assignmentStartedDescription)}
      </Typography>
      <Typography variant="body2" style={{ fontWeight: 300 }}>
        {getTranslation(m.assignmentStartedDescription2)}
      </Typography>
      <Box className={classes.actionItem}>
        <HwtButton variant="outlined" onClick={closeModal}>
          {getTranslation(m.cancel)}
        </HwtButton>
        <HwtButton
          className={classes.btnWarn}
          variant="contained"
          onClick={withCloseModal(onSubmit)}
        >
          {getTranslation(m.yesUnassign)}
        </HwtButton>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex !important',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '315px',
    width: '616px',
    ...ModalPadding,
    backgroundColor: '#fff'
  },
  actionItem: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  btnWarn: {
    backgroundColor: '#D12348',
    '&:disabled': {
      border: 'none'
    }
  }
}));
